<template>
  <b-card
    :title="title"
    :img-src="image ? api_url + image : default_img"
    :img-alt="title"
    img-top
  >
    <b-card-text>
      <div v-html="handled_contents"></div>
      <br v-if="is_expanded" />
      <a v-if="contents.length > length" @click="expand" class="text-primary">{{
        is_expanded ? "收起" : "......更多"
      }}</a>
      <hr />
      <div class="text-right">發佈時間: {{ handled_create_at }}</div>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: "tips_card",
  props: {
    title: {
      type: String,
      required: true,
    },
    contents: {
      type: String,
      required: true,
    },
    image: {
      type: String,
    },
    length: {
      type: Number,
      default: 100,
    },
    create_at: {
      type: String,
    },
  },
  data() {
    return {
      api_url: process.env.VUE_APP_API_URL,
      default_img: require("@/assets/default_tips.png"),
      is_expanded: false,
    };
  },
  computed: {
    handled_contents() {
      if (this.contents.length >= this.length && !this.is_expanded) {
        return this.contents.substring(0, this.length);
      }
      return this.contents;
    },
    handled_create_at() {
      let create_at = new Date(this.create_at);
      return create_at.toLocaleDateString("zh-hant", {
        year: "numeric",
        month: "short",
      });
    },
  },
  methods: {
    expand() {
      this.is_expanded = !this.is_expanded;
    },
  },
};
</script>
